<div class="estadistica-ley-page">
  <div class="container">
    <div class="image-container">
      <img src="https://www.unipay.cl/api/descargaArchivo/estadistica.jpg" alt="Estadísticas Ley 21.231" class="estadistica-image">
    </div>
  </div>
</div>
